export default __webpack_public_path__ + "static/media/bonus2.ac5fa2bf.webm";